import type { QueryClient } from '@tanstack/react-query';

const clients = new Set<QueryClient>();

export function registerClient(client: QueryClient) {
  clients.add(client);
}

export function invalidateQueries(queryKey: string[]) {
  clients.forEach((qc) => {
    qc.invalidateQueries({ queryKey });
  });
}
